import { Component, OnInit, Input } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-modal-shops',
  templateUrl: './modal-shops.component.html',
  styleUrls: ['./modal-shops.component.scss'],
})
export class ModalShopsComponent implements OnInit {
  @Input() shop: any[];
  @Input() pay = false;
  constructor(
    private req: AdminServiceService,
  ) { }

  ngOnInit() {
  }
  typeOf(value) {
    return value === null ? false : typeof value;
  }
  filtrar(value) {
    return !value.includes('id_');
  }
  async refusePay(id) {
    this.req.changeStatePay(id).subscribe((res: any) => {
    });
  }
  async approvePay(id) {
    this.req.changeStatePay(id).subscribe((res: any) => {
    });
  }
}
